import React from 'react';

const Guestlayout = (props) => {
    return (
        <div>
            {props.children}
        </div>
    );
}

export default Guestlayout;